import { AccountOpeningMetadataData } from '@/endpoints/types';
import { OpenAccountMetadataOption } from '@/store/openAccount/types';

export const metadataStringAdapter = (item: AccountOpeningMetadataData): OpenAccountMetadataOption<string> => ({
    value: item.Value.toString(),
    text: item.Text,
    metadata: {},
    Description: item.Description
});

export const metadataNumberAdapter = (item: AccountOpeningMetadataData): OpenAccountMetadataOption<number> => ({
    value: +item.Value,
    text: item.Text,
    metadata: {},
    Description: item.Description
});